import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  position: relative;
`;

export const Background = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  margin: 0 auto;
`;

export const Video = styled.div`
  display: flex;
  align-items: center !important;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  position: relative;
  display: block;
  overflow: hidden;

  video {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    min-height: 100vh;
    object-fit: cover;
  }
`;
